import AccountHeader from "../components/AccoutHeader";
import {
	useCurrentUser,
} from "~/hooks";
import AccountFormInfo from "../components/Forms/AccountFormInfo";

function AccountInfo() {

	const currentUser = useCurrentUser();

	return (
		<div className="container">
			<AccountHeader active={'info'} />
			<section><AccountFormInfo currentUser={currentUser} /></section>
		</div>
	)
}

export default AccountInfo;